import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';

// Composants
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';

//Modèles
import { ConversationItem } from 'src/app/@shared/models/messaging/conversation-item.model';
import { File } from 'src/app/@shared/models/file/file.model';
import { AvatarComponent } from "../../../../@shared/components/user/avatar/avatar.component";

@Component({
	selector: 'app-conversation-details-item',
	imports: [
		CommonModule,
		AvatarModule,
		AvatarComponent
	],
	templateUrl: './conversation-details-item.component.html',
	styleUrl: './conversation-details-item.component.scss'
})
export class ConversationDetailsItemComponent extends BaseComponent {

	/*----------------------------------------------------------------------------------------
	 * Gestion de la vue
	 ----------------------------------------------------------------------------------------*/

	protected override observeComponent: boolean = true;
	protected override observerThreshold: number = 1;

	/*----------------------------------------------------------------------------------------
	 * Données
	 ----------------------------------------------------------------------------------------*/

	private _item!: ConversationItem;
	public get item(): ConversationItem {
		return this._item;
	}
	@Input()
	public set item(value: ConversationItem) {
		this._item = value;
	}

	/*----------------------------------------------------------------------------------------
	 * Accesseurs
	 ----------------------------------------------------------------------------------------*/



	/*----------------------------------------------------------------------------------------
	 * Méthodes publiques
	 ----------------------------------------------------------------------------------------*/

	public getHighlightedContent(item: ConversationItem): string {
		// Surlignage borné : on n'enveloppe que les @Nom des contacts réellement mentionnés
		// (mentionsInternal ∪ mentionsExternal), pas de parsing libre du texte.
		let content = this.getFormattedContent(item.content || '');
		const mentions = [...(item.mentionsInternal || []), ...(item.mentionsExternal || [])];
		// Tri par longueur de label décroissante pour éviter qu'un nom préfixe d'un autre soit traité en premier
		const labels = mentions
			.map(contact => contact.fullName)
			.filter(label => !!label)
			.sort((a, b) => b.length - a.length);
		for (const label of labels) {
			const regex = new RegExp('@' + this._escapeRegExp(label), 'g');
			content = content.replace(regex, '<span class="mention">@' + label + '</span>');
		}
		return content;
	}

	public getTruncatedFileName(fileName: string): string {
		const maxLength = 15;
		if (fileName.length <= maxLength) {
			return fileName;
		}
		return fileName.substring(0, maxLength) + '...';
	}

	public onAttachmentClick(attachment: File): void {
		if (attachment.isPdf) {
			this.fileService.downloadFile$(attachment.id, false).subscribe(blob => {
				const blobURL = URL.createObjectURL(blob);
				const newTab = window.open(blobURL, '_blank');
				if (newTab) {
					newTab.addEventListener('beforeunload', () => {
						URL.revokeObjectURL(blobURL);
					});
				}
			});
		} else {
			this.fileService.downloadFile$(attachment.id, false).subscribe(blob => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = attachment.fileName;
				link.click();
				window.URL.revokeObjectURL(link.href);
			});
		}
	}

	/*----------------------------------------------------------------------------------------
	 * Méthodes protégées
	 ----------------------------------------------------------------------------------------*/

	protected override componentVisibleCallback(): void {
		if (!this.item.hasStatus(this.Status.Read)) {
			this.conversationItemService.markAsRead(this.item);
		}
	}

	/*----------------------------------------------------------------------------------------
	 * Méthodes privées
	 ----------------------------------------------------------------------------------------*/

	private _escapeRegExp(value: string): string {
		return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
}
